import { Typography, styled } from '@mui/material';

const StyledImageUploadText = styled(Typography)(({ theme }) => ({
  color: theme.palette.white.main,
  marginTop: 1
}));

export default StyledImageUploadText;
